import { formatDate } from '@side/pantry';

const INTERNAL_PATH = '/txm';
const PARAMS = new URLSearchParams({
  utm_source: 'hp',
  utm_medium: 'ltc',
}).toString();

export const buildLastViewedText = (timestamp: string) => {
  const dateTime = new Date(timestamp);

  const formattedDate = formatDate(dateTime, 'shortDate');
  const formattedTime = formatDate(dateTime, 'time');

  return `Last Viewed at ${formattedTime} on ${formattedDate}`;
};

export const isInternalLink = (path: string) => path.startsWith(INTERNAL_PATH);

export const getHref = (path: string) => {
  const isInternal = path.startsWith(INTERNAL_PATH);
  const pathname = isInternal ? path.slice(INTERNAL_PATH.length) : path;
  const separator = pathname.includes('?') ? '&' : '?';

  return `${pathname}${separator}${PARAMS}`;
};

export const getInteractionIdFromPath = (path: string) => {
  switch (true) {
    case path.startsWith('/txm'):
    case path.startsWith('/payment'):
      return path.split('/').at(3);
    case path.startsWith('/audit'):
      return path.split('/').at(2);
    default:
      return null;
  }
};

export const getAnalyticsRouteNameFromPath = (path: string) => {
  if (path.startsWith('/audit')) {
    return 'audit';
  }

  return path.substring(path.lastIndexOf('/') + 1);
};

export const shouldOpenInNewTab = (path: string) =>
  !path.startsWith('/audit') &&
  !path.startsWith('/identity') &&
  !path.startsWith('/payment') &&
  !path.startsWith(INTERNAL_PATH);
